<template>
  <div class="license-error-container font">
    <div class="license-error-inner">
      <h1>{{ $t("networkComputer.autoCloseOnAdminDisconnect") }}</h1>
      <h3>{{ count }}</h3>
    </div>
  </div>
</template>
<script>
import shutdown from "@/services/shutdown";
export default {
  data() {
    return {
      count: 10,
    };
  },
  mounted() {
    this.count = globalThis.OTZAR_BASIC_INFO.networkTimerBeforeClose;
    let counter = setInterval(() => {
      this.count--;
      if (this.count == 0) clearInterval(counter);
    }, 1000);
    setTimeout(() => {
      shutdown.shutdown(shutdown.SHUTDOWN_CODE);
    }, this.count * 1000);
  },
};
</script>

<style lang="scss" scoped>
.license-error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f7f7f7;
}
h1 {
  margin: 0;
  font-size: 35px;
  font-weight: bolder;
}
h2 {
  font-size: 35px;
  margin-top: 17px;
  font-weight: normal;
}
.error-code {
  color: var(--custom-color1);
  border-top: 1px solid;
  border-bottom: 1px solid;
  display: flex;
  align-items: center;
  width: fit-content;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: 0 auto 50px auto;
  font-size: 20px;
}
.contact {
  font-size: 16px;
}
</style>
